import { render, staticRenderFns } from "./CreaJuego.vue?vue&type=template&id=81c9ef9e&"
import script from "./CreaJuego.vue?vue&type=script&lang=js&"
export * from "./CreaJuego.vue?vue&type=script&lang=js&"
import style0 from "./CreaJuego.vue?vue&type=style&index=0&id=81c9ef9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports